import React, {useEffect, useMemo, useState} from "react";
import { FormSections, ProgramContainer } from "../../entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import axios from "axios";
import DataUtils from "../../utilities/DataUtils";
import Utils from "../../utilities/Utils";
import ReCaptchaV3 from "../captcha/CaptchComponent";
import ReCaptchaButton from "../captcha/captcha-button";
import { getCxpMessages } from "../../services/CxpProfileService";

interface Props {
    token: string;
    programContainer: ProgramContainer;
    isEng: boolean;
    section: FormSections;
    onButtonClick: (data) => void; // Callback function type
    callback?: (p: ProgramContainer) => void;
}

const CHCHandleSubmitComponent: React.FC<Props> = ({ programContainer, isEng, section, onButtonClick, callback }) => {
    const [validationErrMsg, setValidationErrMsg] = useState<any[]>([]);
    const [isBusy, setIsBusy] = useState<boolean>(false);
    const [confirmationVisible, setConfirmationVisible] = useState<boolean>(false);
    const [summaryVisible, setSummaryVisible] = useState<boolean>(true);
    const [transactionId, setTransactionId] = useState<string>('');
    const [uploadReceiptSuccess, setUploadReceiptSuccess] = useState<boolean>(false);
    const [submissionError, setSubmissionError] = useState<boolean>(false);

    const handleSubmit = (token: string) => {
        let invalidControlList = FormValidationUtils.invalidControls(section);

        if (invalidControlList.filter(p => p.Datatype !== 'Address').length > 0) {
            const errs = invalidControlList.filter(p => p.Datatype !== 'Address')
            setValidationErrMsg(errs);
            window.scrollTo(0, 0);
        } else {

            let url = process.env.SUBMIT_URL || programContainer.UpdateAPI;
            const data = DataUtils.collectFormValue(programContainer);
            const DOB = new Date(data.Child__date__of__birth);
            const postalCode = Utils.extractPostalCode(data.Address__Search || data.Mailing__address);

            const payload = {
                childCardNumber: data.Child__health__card__number__and__version__code,
                childBirthRegNumber: data.Child__birth__registration__number,
                guardianHealthNumber: data.Health__card__number__and__version__code,
                childFirstName: data.Child__first__name,
                childLastName: data.Child__last__name,
                parentFirstName: data.First__name,
                parentLastName: data.Last__name,
                postalCode: postalCode,
                phoneNumber: data.Primary__phone__number,
                childBirthYear: DOB.getFullYear(),
                childBirthMonth: DOB.getMonth() + 1,
                childBirthDay: DOB.getDate(),
                mailAddress: data.Address__Search || data.Mailing__address,
                language: isEng ? "EN" : "FR",
                token,
                userId: programContainer.Profile?.userId
            };

            setIsBusy(true);

            axios.post(url, payload)
                .then(res => {
                    if (res.data.RenewWebResponse.statusCode !== 0) {
                        setSummaryVisible(false);
                        setSubmissionError(true);
                        setIsBusy(false);
                        return;
                    }
                    setConfirmationVisible(true);
                    setSummaryVisible(false);
                    setTransactionId(res.data.RenewWebResponse.transactionId);
                    setUploadReceiptSuccess(res.data.RenewWebResponse.uploadReceiptSuccess);
                  
                    if (data.email) {
                        const emailPayload = {
                            "to": data.email,
                            "transactionId": res.data.RenewWebResponse.transactionId,
                            "language": isEng ? "EN" : "FR"
                        };
                        const emailUrl = process.env.EMAIL_URL;
                        axios.post(emailUrl, emailPayload)
                            .then(() => {
                                
                            })
                            .catch(ex =>  {          
                               console.log(ex);
                            })
                            .finally(() => {
                                setIsBusy(false);
                            });
                    }

                    if (programContainer.Profile?.userId && programContainer.Profile?.token) {
                        getCxpMessages(programContainer.Profile?.token, { pageNumber: 1, pageSize: 20, search: '' })
                            .then(messages => {
                                console.log('fetch message after subimtting:', messages);
                                if (messages?.messages) {
                                    const unread1 = messages.messages.filter(msg => !msg.isRead).length ?? 0;
                                    const unread2 = programContainer.Profile?.messages?.filter(msg => !msg.isRead).length ?? 0;
                                    if (unread1 !== unread2) {
                                        programContainer.Profile.messages = messages.messages;
                                        callback(programContainer);
                                    }
                                };
                            })
                            .catch(ex => {
                                console.log('fetch message after subimtting failer:', ex);
                            })
                            .finally(() => {
                                setIsBusy(false);
                            });
                    } 
                })
                .catch(err => {
                    setIsBusy(false);
                    setSummaryVisible(false);
                    setSubmissionError(true);
                    console.log(err);
                })
                .finally(() => {
                    setIsBusy(false);
                });
        }
    };

    const props = useMemo(() => ({
        isBusy,
        confirmationVisible,
        summaryVisible,
        transactionId,
        uploadReceiptSuccess,
        submissionError,
        validationErrMsg
    }), [isBusy, validationErrMsg]);

    useEffect(() => {
        onButtonClick(props);
    }, [props]);

    return (
        <div className="ontario-margin-top-24-!">
            <ReCaptchaV3 lang={isEng ? 'en' : 'fr'}>
                <ReCaptchaButton key={validationErrMsg.toString()}
                    title={isEng ? 'Submit' : 'Soumettre'}
                    action='submitCHC'
                    buttonHandler={handleSubmit}>
                    {isEng ? "Submit" : "Soumettre"}
                </ReCaptchaButton>
            </ReCaptchaV3>
        </div>
    );
};

export default CHCHandleSubmitComponent;
